module.exports = __webpack_public_path__ + "img/f4bf21178d1589876e1b05cc0b89e46d.png";